const PLAYER = {
  HANDLE_CHANGE_PROPERTIES_PACK: 'PLAYER.HANDLE_CHANGE_PROPERTIES_PACK',
  HANDLE_CHANGE_PROPERTY: 'PLAYER.HANDLE_CHANGE_PROPERTY',
  HANDLE_DISPOSE: 'PLAYER.HANDLE_DISPOSE',
  HANDLE_INFO_EVENT: 'PLAYER.HANDLE_INFO_EVENT',
  HANDLE_MEDIA_ERROR_EVENT: 'PLAYER.HANDLE_MEDIA_ERROR_EVENT',
  HANDLE_STOP: 'PLAYER.HANDLE_STOP',
  HANDLE_SEEKING: 'PLAYER.HANDLE_SEEKING',
  HANDLE_PLAYER_COMPLETED: 'PLAYER.HANDLE_PLAYER_COMPLETED',
  HANDLE_LEAVE_PIP_ON_PAUSE: 'PLAYER.HANDLE_LEAVE_PIP_ON_PAUSE',
  ERROR: 'PLAYER.ERROR',
};

export default PLAYER;
